<template>
    <section>
      <navigation :activeTab='"team"'></navigation>

      <div class="mdl-grid center-items">
        <div class="mdl-cell mdl-cell--12-col center-items">
          <div v-if="teamKey!='unknown'">
            <h4 class="center-align">{{teamName}}</h4>
            <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label has-placeholder">
                <select class="mdl-textfield__input form-control" v-model="weekSelected" :required="true">
                  <option :selected="true" value="season">Season</option>
                  <option v-for="w of weeks" v-bind:value="w['.key']">Week {{ w['.value'] }}</option>
                </select>
                <label class="mdl-textfield__label" for="viewStatsSelect">View Stats By</label>
              </div>

            <div v-if="havePastPlayers">
              <PastPlayerTables tableName="pastbatters" :weekKey=weekSelected :players="pastPlayers"/>
            </div>
            <div v-else>
              <h5 class="center-align">Batters</h5>
              <BatterTable tableName="batters" :weekKey=weekSelected :batters="batters" :ownershipView="teamKey"  :leagueKey="leagueKey"/>

              <h5 class="center-align">Pitchers</h5>
              <PitcherTable tableName="pitchers" :pitchers="pitchers" :weekKey=weekSelected :ownershipView="teamKey" :leagueKey="leagueKey" />
            </div>
          </div>
        </div>
      </div>
    </section>
</template>

<script>
import BatterTable from "@/components/BatterTable.vue";
import PitcherTable from "@/components/PitcherTable.vue";
import PastPlayerTables from "@/components/PastPlayerTables.vue";


import { db } from '../db'
import firebase from "firebase";
import navigation from "@/components/NavBar.vue";

export default {
  data() {
    return {
      batters: [],
      pitchers: [],
      weeks: [],
      weekSelected: "season",
      user: null,
      teamName: "",
      weekBatters: null,
    }
  },
  props: {
    leagueKey: { 
      type: String, // not 'string'
      required: true,
      default: ""
     },
    teamKey : { 
      type: String, // not 'string'
      required: true,
      default: "unknown"
     },
  },
  components: {
    navigation,
    BatterTable,
    PitcherTable,
    PastPlayerTables
  },
  firebase: {
    batters: db.ref('batters/players/').orderByChild("hits"),
    pitchers: db.ref('pitchers/players/').orderByChild("ip"),
    weeks: db.ref('weeks2021/'),
  },
  computed: {
    havePastPlayers() {
      return this.weekBatters && this.weekBatters[this.weekSelected] && this.weekBatters[this.weekSelected]['players']
    },
    pastPlayers(){
      if (this.havePastPlayers){
        return this.weekBatters[this.weekSelected]['players']
      } 
      return {}
    }
  },
  created() {
    firebase.auth().onAuthStateChanged(async (user) => {
        if (user) {
            this.user = user; 
            let tmp = this.teamName
            await db.ref('/leagues/'+this.leagueKey+'/teams/'+this.teamKey+"/teamName").once('value',function(snapshot){
              tmp = snapshot.val()
            })
            this.teamName = tmp

            if (this.leagueKey != 'noinit' && this.leagueKey != 'notfound' && this.teamKey != 'unknown' && this.user != null){
              let snap = await db.ref('/leagues/'+this.leagueKey+'/teams/'+this.teamKey+'/season').once('value')
              this.weekBatters = snap.val()
            }

        }
    });
  }
}

</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Team.vue